import { TranslateService } from '@ngx-translate/core';
import { ApiSelectorService } from 'src/app/core/services/api-selector/api-selector.service';
import { Component } from '@angular/core';
import { App } from '@capacitor/app';
import { Platform, MenuController, AlertController } from '@ionic/angular';
import { NetworkService } from './core/services/network/network.service';
import { UtilsService } from './core/services/utils/utils.service';
import { Router } from '@angular/router';
import { User } from './models/user.model';
import { Subscription } from 'rxjs';
import { LoginService } from './core/services/login/login.service';
import { HttpHelpersService } from './core/services/http-helpers/http-helpers.service';
import { NotificationsService } from './core/services/notifications/notifications.service';
import { PushNotifications, PushNotificationSchema } from '@capacitor/push-notifications';
import { config } from './core/config';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { register } from 'swiper/element/bundle';
import { SplashScreen } from '@capacitor/splash-screen';
import { Browser } from '@capacitor/browser';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { MenuService } from './core/services/menu/menu.service';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';


declare let window: any;
register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  public user: User;
  public version: string;
  private subscription: Subscription;

  public appPages;
  private subscriptions: Subscription[] = [];

  disableMenu = true;

  private readyApp: () => void;
  private isAppInForeground: Promise<void> = Promise.resolve();
  private connectionSubscription: Subscription;
  public isOnline: boolean = false;
  private routerSub = null;
  versionSelected: any;
  readonly message = environment.message;

  constructor(
    public platform: Platform,
    public platformServ: NetworkService,
    public menu: MenuController,
    private utils: UtilsService,
    private router: Router,
    private loginService: LoginService,
    private networkService: NetworkService,
    private httpHelper: HttpHelpersService,
    private notificationService: NotificationsService,
    private alertController: AlertController,
    private location: Location,
    private apiSelector: ApiSelectorService,
    private statusBar: StatusBar,
    private translate : TranslateService,
    private menuService: MenuService
  ) {
    try {
      this.initializeApp();
    } catch (e) {
      console.log(e)
    }

    this.subscriptions.push(
      this.menuService.appPages$.subscribe(pages => {
        this.appPages = pages;
      })
    );
  }

  async initializeApp() {
      if (this.platform.is("android")) {  
      await EdgeToEdge.setBackgroundColor({ color: '#000000' });
    }
    this.translate.addLangs(['es', 'pt']);
    this.translate.setDefaultLang('es');
    try {
      let { value } = await this.utils.getLenguage();
      let browserLang = value
      if(browserLang === null){
        this.detectLanguage();
      }
      else if(browserLang === 'es' || browserLang === 'pt'){
        this.translate.use(browserLang);
        this.utils.setLenguage(browserLang);
      } else {
        browserLang == 'es'
        this.translate.use(browserLang);
        this.utils.setLenguage(browserLang);
      }
     } catch (error) {
       this.detectLanguage();
     }
    await this.platform.ready();
    if (!this.platform.is("ios")) {
      await SplashScreen.show({
        autoHide: false,
      }).finally(() => {
        setTimeout(async () => {
          await SplashScreen.hide();
        }, 500);
      });
    } else {
      await SplashScreen.hide();
    }
    try {
      if (this.platform.is('capacitor')) {
        try {
          await PushNotifications.requestPermissions();
        } catch (e) {
          atatus.notify(new Error(JSON.stringify({
            error: e,
            method: 'requestPermissions',
            file: 'app.component.ts'
          })));
        }
      }
      this.platform.pause.subscribe(() => {
        this.isAppInForeground = new Promise(resolve => { this.readyApp = resolve });
      });

      this.platform.resume.subscribe(async () => {
        let permStatus = await PushNotifications.checkPermissions();
        if (permStatus.receive !== 'granted') {
          await PushNotifications.removeAllDeliveredNotifications();
        } else {
          this.utils.saveInStorage("pushHasPermission", true);
        }
        this.readyApp();
      })

      const host = window.location.host.split('.');
      if (host[0] !== 'localhost' && host.length > 1 && isNaN(+host[1]))
        this.utils.saveInStorage('company', host[0]);
      // this.utils.saveInStorage('company', 'demo');

      if (this.platform.is('capacitor')) {

        this.networkService.connectionStatus();
        this.connectionSubscription = this.networkService.getConnectionStatus()
          .subscribe(data =>
            this.isOnline = data
          );
        this.networkService.getInitialConecctionState().then(data => this.isOnline = data)

        this.statusBar.overlaysWebView(true);

        this.initializeNotifications();
        this.utils.saveInStorage('alreadyLaunch', true);

      }




      try {
        let user: User = await this.utils.getFromStorage('user');
        if (/*localStorage.getItem('platform') !== 'desktop' && */user) {
          this.httpHelper.setHeader(user.access_token)
        }
      } catch (e) {
      }


      this.router.events.subscribe((url: any) => {
        // if (url.url && (url.url === '/' || url.url === '/login' || url.url === '/pre-load'))
        //   this.disableMenu = false;
        // else
        //   this.disableMenu = true;
        if (url.url) {
          switch (url.url) {
            case '/login':
            case '/register':
            case '/pre-load':
            case '/verify-account':
            case '/welcome':
              this.disableMenu = true;
              break;
            default:
              this.disableMenu = false;
              break;
          }
        }
      });
      this.userUpdate();

      if (!this.routerSub)
        this.router.events.subscribe(() => {
          this.appPages.forEach(element => element.active = false)
          const page = this.appPages[this.appPages.findIndex(el => el.url === this.location.path())]
          if (page)
            this.appPages[this.appPages.findIndex(el => el.url === this.location.path())].active = true;
        });
    } catch (e) {
      console.log(e);
      atatus.notify(new Error(JSON.stringify({
        error: e,
        method: 'initializeApp()',
        file: 'app.component.ts'
      })));
    } finally {
      setTimeout(() => {
        if (this.platform.is('ios'))
          this.askTrackingPermission();
      }, 1000);
    }

    this.versionSelected = await this.utils.getFromStorage('API_SELECTED').catch(() => 'master');
    this.apiSelector.changeEnvironment(this.versionSelected);
  }



  async userUpdate() {
    if (this.platform.is('capacitor')) {
      try {
        this.version = await (await App.getInfo()).version;
      } catch (e) {
        console.log(e)
      }
    } else {
      this.version = config.version
    }

    this.subscription = this.loginService.getUser().subscribe(async (user) => {
      if (user) {
        this.user = user;
        this.appPages.forEach(element => {
          element.active = false;
        });
        this.appPages[0].active = true;
      }
    });

    if (!this.user) {
      try {
        this.user = await this.utils.getFromStorage('user');
      } catch { }
    }
    // this.router.navigate(['/pre-load']);

  }

  async initializeNotifications() {
    try {
      await PushNotifications.addListener('pushNotificationReceived', async notification => {
        console.log('pushNotificationReceived')
        await this.isAppInForeground;
        let total = await this.utils.getFromStorage('totalNotifications');
        total += 1;
        this.utils.saveInStorage('totalNotifications', total);
        //this.pushNotificationSchema.badge === total;
        notification.data['isBackround'] = false;
        this.notificationService.manageNotification(notification.data);
      });

      await PushNotifications.addListener('pushNotificationActionPerformed', async notification => {
        console.log('pushNotificationActionPerformed')
        notification.notification.data['isBackround'] = true;
        this.notificationService.manageNotification(notification.notification.data);
      })

    } catch (e) {
      atatus.notify(new Error(JSON.stringify({
        error: e,
        method: 'initializeNotifications()',
        file: 'app.component.ts'
      })));
    }
  }

  activateRoute(index) {
    if (index === this.appPages.length - 1)
      this.logout();
    else if (this.appPages[index].url === '/help-center') {
      if (this.platform.is('capacitor')) {
        if (this.isOnline) {
          Browser.open({ url: 'http://www.calidadcloud.com/posventa-acceso.html' })
        } else
          this.utils.showMessage(this.translate.instant('app-component.Sin conexión a internet'));
      } else
        window.open('http://www.calidadcloud.com/posventa-acceso.html', '_system');
    } else if (this.appPages[index].url === '/email-validation') {

    } else {
      this.appPages.forEach(element => {
        element.active = false;
      });
      this.appPages[index].active = true;
      this.router.navigate([this.appPages[index].url]);
    }
  }

  async logout() {
    const fd = new FormData();
    if (this.platform.is('capacitor')) {
      const { uuid } = await this.utils.getFromStorage('user');
      fd.append('uuid', uuid)
    }

    this.utils.removeFromStorage('API_SELECTED');
    this.apiSelector.changeEnvironment(undefined);
    this.loginService.logout(fd)
      .subscribe(async () => {
        document.body.setAttribute('class', 'light');
        this.utils.logOutHelper();
      });
  }

  ccloudPage() {
    this.utils.openCCloudPage(this.isOnline);
  }

  askTrackingPermission() {
    if (this.platform.is('cordova') && this.platform.is('ios')) {

      if (window.cordova) {
        console.log('trying to request permission ');
        window.cordova.exec(win, fail, 'idfa', "requestPermission", []);
      }
    }

    function win(res) {
      console.log('success ' + JSON.stringify(res));
    }
    function fail(res) {
      console.log('fail ' + JSON.stringify(res));
    }
  }

  readTrackingPermission() {

    if (this.platform.is('cordova') && this.platform.is('ios')) {

      if (window.cordova) {
        window.cordova.exec(win, fail, 'idfa', "getInfo", []);
      }
    }

    function win(res) {
      console.log('success  ' + JSON.stringify(res));
    }
    function fail(res) {
      console.log('fail ' + JSON.stringify(res));
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  async menuOpened() {
    this.versionSelected = await this.utils.getFromStorage('API_SELECTED').catch(() => 'master');
    this.menuService.menuTranslate();
  }

  detectLanguage(){
    let browserLang = this.translate.getBrowserLang()!;
    if(this.platform.is('desktop')){
      browserLang = Intl.DateTimeFormat().resolvedOptions().locale.split('-')[0];
      browserLang = browserLang || 'es';
    }
    this.translate.use(browserLang);
    if(browserLang !== 'es' && browserLang !== 'pt'){
      this.utils.setLenguage('es');
    } else {
      this.utils.setLenguage(browserLang);
    }
  }

}


// cordova plugin rm cordova-plugin-idfa